import React from 'react';
import '../lifehacks/ArticleFull.css';

const PetTravelGuide = () => {
  return (
    <div className="article-full">
      <h1 className="article-title">
        🐾 Как перевезти питомца из России в Бразилию: подробный гайд
      </h1>

      <p className="article-text">
        Планируете переезд в Бразилию и не представляете жизнь без любимого питомца? Отлично! Перевезти кошку или собаку из России в Бразилию вполне реально, но важно соблюсти все правила: от прививок до оформления международных документов.
      </p>
      <p className="article-text">
        В этой статье — подробный пошаговый алгоритм: какие прививки нужны, как получить сертификаты, как договориться с авиакомпанией и что делать по прилёту.
      </p>

      <h3 className="article-section-title">📌 Какие животные разрешены к ввозу в Бразилию?</h3>
      <p className="article-text">Разрешён без специального разрешения:</p>
      <ul className="article-list">
        <li>🐶 Собаки</li>
        <li>🐱 Кошки</li>
      </ul>
      <p className="article-text">
        Для ввоза других животных (птиц, грызунов, рептилий и др.) потребуется отдельное согласование с Министерством сельского хозяйства Бразилии (MAPA).
      </p>

      <h3 className="article-section-title">✅ Шаг 1. Сделайте прививки</h3>
      <p className="article-text">🐶 Для собак:</p>
      <ul className="article-list">
        <li>Бешенство — обязательна, сделана не ранее чем за 30 дней и не позднее чем за 12 месяцев до вылета</li>
        <li>Комплексная вакцина (DHPPiL) — от чумы, гепатита, парвовируса, лептоспироза, парагриппа</li>
      </ul>
      <p className="article-text">🐱 Для кошек:</p>
      <ul className="article-list">
        <li>Бешенство — те же сроки</li>
        <li>Тройная вакцина (V3) — от ринотрахеита, калицивироза, панлейкопении</li>
      </ul>
      <p className="article-text">Все прививки должны быть указаны в ветеринарном паспорте с печатями и подписями.</p>

      <h3 className="article-section-title">✅ Шаг 2. Обработка от паразитов</h3>
      <p className="article-text">Примерно за 10–15 дней до вылета:</p>
      <ul className="article-list">
        <li>Дайте средство от внутренних паразитов (глистов)</li>
        <li>Проведите обработку от внешних паразитов (блох и клещей)</li>
      </ul>
      <p className="article-text">Эти процедуры также должны быть указаны в паспорте.</p>

      <h3 className="article-section-title">✅ Шаг 3. Получите ветеринарное свидетельство (форма №5а)</h3>
      <p className="article-text">
        Не ранее чем за 5 дней до вылета вы обращаетесь в государственную ветеринарную клинику по месту жительства и оформляете форму №5а.
      </p>
      <p className="article-text">Что взять с собой:</p>
      <ul className="article-list">
        <li>Питомца</li>
        <li>Ветеринарный паспорт</li>
        <li>Документы на прививки и обработки</li>
      </ul>

      <h3 className="article-section-title">✅ Шаг 4. Заверьте справку в Россельхознадзоре</h3>
      <p className="article-text">
        С этой формой (№5а) вы идёте в территориальное управление Россельхознадзора, где оформят Международный ветеринарный сертификат — на английском или португальском языке. Именно его требуют бразильские службы на границе.
      </p>
      <p className="article-text">
        ⚠️ <strong>Важно:</strong> Лучше заранее уточнить, где находится ближайшее отделение Россельхознадзора и нужно ли записываться.
      </p>

      <h3 className="article-section-title">✅ Шаг 5. Свяжитесь с авиакомпанией — до покупки билета</h3>
      <p className="article-text">
        ⚠️ <strong>Очень важно:</strong> Не покупайте билет на себя до согласования с авиакомпанией перевозки животного. Авиакомпании часто ограничивают количество животных на рейс. Особенно это касается перевозки в салоне (кабине) — обычно не более 2–4 животных.
      </p>
      <p className="article-text">Что нужно сделать:</p>
      <ul className="article-list">
        <li>Позвоните или напишите в авиакомпанию:
          <ul>
            <li>Укажите, что вы планируете перелёт с питомцем</li>
            <li>Сообщите вес животного с переноской, породу и дату вылета</li>
          </ul>
        </li>
        <li>Получите от авиакомпании подтверждение, что животное может лететь в салоне (или багаже)</li>
        <li>Только после этого покупайте билет на себя и бронируйте место для животного</li>
      </ul>

      <h3 className="article-section-title">✅ Шаг 6. Подготовьте переноску</h3>
      <p className="article-text">Требования к переноске (по стандарту IATA):</p>
      <ul className="article-list">
        <li>Прочная, хорошо вентилируемая</li>
        <li>Животное должно в ней могло встать, повернуться и лечь</li>
        <li>Герметичное дно (например, впитывающая пелёнка)</li>
        <li>Крепкий замок (без возможности случайного открытия)</li>
        <li>Этикетка с надписью “Live Animal” и данными владельца</li>
      </ul>

      <h3 className="article-section-title">✅ Шаг 7. Перелёт</h3>
      <p className="article-text">
        Прибывайте в аэропорт заранее — с животными часто оформление занимает больше времени.
      </p>
      <p className="article-text">Иметь с собой:</p>
      <ul className="article-list">
        <li>Международный ветеринарный сертификат</li>
        <li>Оригинал ветеринарного паспорта</li>
        <li>Подтверждение брони животного</li>
        <li>Переноску</li>
        <li>Воду и лёгкий корм (если перелёт долгий)</li>
      </ul>

      <h3 className="article-section-title">✅ Шаг 8. По прилёту в Бразилию</h3>
      <p className="article-text">
        На границе ваш питомец пройдёт ветеринарный контроль (MAPA). Вас попросят предъявить:
      </p>
      <ul className="article-list">
        <li>Международный ветеринарный сертификат</li>
        <li>Ветпаспорт</li>
        <li>Документы об обработке от паразитов</li>
      </ul>
      <p className="article-text">Карантин НЕ требуется, если документы в порядке.</p>

      <h3 className="article-section-title">✅ Шаг 9. После переезда</h3>
      <p className="article-text">Если вы планируете остаться в Бразилии надолго:</p>
      <ul className="article-list">
        <li>Зарегистрируйте животное в местной ветеринарной клинике</li>
        <li>Регулярно обновляйте прививки по местному графику</li>
        <li>Узнайте местные правила (например, наличие поводка, намордника, выгул)</li>
      </ul>

      <h3 className="article-section-title">🧳 Итоговый чеклист перед вылетом</h3>
      <ul className="article-list">
        <li>Прививка от бешенства — <span className="article-note-text">За 30–365 дней</span></li>
        <li>Комплексные прививки — <span className="article-note-text">По графику, не просрочены</span></li>
        <li>Обработка от паразитов — <span className="article-note-text">За 10–15 дней</span></li>
        <li>Ветпаспорт с печатями — <span className="article-note-text">Всегда с собой</span></li>
        <li>Форма №5а — <span className="article-note-text">За 5 дней до вылета</span></li>
        <li>Международный сертификат — <span className="article-note-text">После №5а в Россельхознадзоре</span></li>
        <li>Подтверждение от авиакомпании — <span className="article-note-text">До покупки билета</span></li>
        <li>Переноска — <span className="article-note-text">По стандарту IATA</span></li>
        <li>Вода, пелёнка, корм — <span className="article-note-text">В день перелёта</span></li>
      </ul>

      <h3 className="article-section-title">❗ Часто задаваемые вопросы</h3>
      <p className="article-text"><strong>Нужно ли чипировать животное для Бразилии?</strong></p>
      <p className="article-text">Нет, чип не обязателен, но рекомендуется — особенно если животное потеряется.</p>
      <p className="article-text"><strong>Можно ли везти несколько животных?</strong></p>
      <p className="article-text">Да, но у каждой авиакомпании свои правила. Обычно — не более 2 животных на пассажира, при этом каждый оформляется отдельно.</p>
      <p className="article-text"><strong>Можно ли сделать все документы в частной клинике?</strong></p>
      <p className="article-text">Прививки и обработки — да. Но форму №5а выдают только в госветклиниках, а международный сертификат оформляет только Россельхознадзор.</p>

      <div className="article-note">
        <p className="article-note-text">
          💡 <strong>Полезные советы:</strong><br />
          Сделайте копии всех документов<br />
          Проверьте, чтобы ветеринарный паспорт был без повреждений и с актуальными данными<br />
          Уточните у авиакомпании правила перевозки заранее, чтобы избежать сюрпризов<br />
          Подготовьте питомца к перелёту: приучите к переноске и минимизируйте стресс
        </p>
      </div>
    </div>
  );
};

export default PetTravelGuide;